// THE APPEAL AS THE STEP ON SCREEN LAST HEARD IT, HANDED TO THE RAIL (WALK-FIX-1, R236).
//
// The rail sits beside every step and asks nothing itself. The shell's one `v2Credits` `get` answers it once per page
// load, so a letter written since — Tyler's walk, 2026-10-05: generate, add contact, "Revise", back on step 1 — was not
// in what the rail read, and every step after Details went grey. Every step's own call already carries the appeal's
// snapshot (`appeal`, on every v2 response), so the step on screen hands the one it got to the rail, and the rail reads
// the newest answer the server gave. Nothing is decided here and nothing is called: it is a pipe from a response to a
// sibling.

import { createContext, useContext, useEffect } from "react";
import type { AppealSnapshot } from "@contract";

/** Set by the workspace (`Work`, components/layout.tsx); null outside it, where a report goes nowhere. */
export const AppealReportContext = createContext<((appeal: AppealSnapshot) => void) | null>(null);

/** A step hands the rail the snapshot its own call answered with. Null (pending, failed, no snapshot) hands nothing. */
export function useReportAppeal(appeal: AppealSnapshot | null): void {
  const report = useContext(AppealReportContext);
  useEffect(() => {
    if (report !== null && appeal !== null) report(appeal);
  }, [report, appeal]);
}
